import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IUserAccountDto } from '@my-aon/auth';
import { ENVIRONMENT } from '@environment';
import { hasValue } from '@my-aon/utils';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AdminAccountsService {
    readonly environment = inject(ENVIRONMENT);
    readonly http: HttpClient = inject(HttpClient);

    private readonly path: string = this.environment.apiUrl + 'Admin/Accounts/';

    public byKey(key: string): Observable<IUserAccountDto> {
        return this.http.get<IUserAccountDto>(`${this.path}${key}`);
    }

    public insertOrUpdate(
        model: IUserAccountDto,
        original: IUserAccountDto
    ): Observable<IUserAccountDto> {

        debugger
        if (!hasValue(model.Id) || !hasValue(original.Id))
            return this.http.post<IUserAccountDto>(this.path, model);
        else
            return this.http.patch<IUserAccountDto>(
                `${this.path}${model.Id}`,
                model
            );
    }

    public resetPassword(
        model: IUserAccountDto,
        request?: ResetPasswordRequest
    ) {
        return this.http.post(
            `${this.path}${model.Id}/ResetPassword`,
            request ?? {}
        );
    }

    public resetMfa(
        model: IUserAccountDto,
        request?: ResetMfaRequest
    ) {
        return this.http.post(
            `${this.path}${model.Id}/ResetMfa`,
            request ?? {}
        );
    }

    public toggleEnabled(model: IUserAccountDto) {
        return this.http.post(`${this.path}${model.Id}/ToggleEnabled`, null);
    }

    public getOktaUserByEmail(email: string) {
        return this.http.post<IUserAccountDto>(`${this.path}Okta/ByEmail`, {
            email,
        });
    }
}

export interface ResetPasswordRequest {
    scheduledAtUtc?: string | null;
}

export interface ResetMfaRequest {
    scheduledAtUtc?: string | null;
}
